import { CustomIconComponentProps } from '@ant-design/icons/es/components/Icon';
import Icon from '@ant-design/icons';
import React from 'react';

const RestoreIconSvg = () =>
	<svg
		fill='currentColor'
		height='1em'
		viewBox='0 0 24 24'
		width='1em'
		xmlns='http://www.w3.org/2000/svg'>
		<path d='M20 22H4V11H6V20H18V11H20V22ZM3 4H21V10H3V4ZM5 6V8H19V6M10.5 18V15H8L12 11L16 15H13.5V18' />
	</svg>;

export const RestoreIcon: React.FC<Partial<CustomIconComponentProps>> = (props) =>
	<Icon
		component={ RestoreIconSvg }
		{ ...props } />;
